import type { Lead } from '@/lib/api';

// Extended lead type with pipeline-specific fields
export interface PipelineLead extends Lead {
  stage_history?: StageHistoryEntry[];
  last_activity?: string;
  next_action?: string;
  days_in_stage?: number;
}

export interface StageHistoryEntry {
  stage: string;
  timestamp: string;
  agent: string;
}

// 10 lead stages based on Icelandic real estate sales process (from NEWPLAN.md)
export const LEAD_STAGES = [
  { id: 'nýr', label: 'Nýr lead', color: '#FEF3C7' }, // Yellow
  { id: 'haft_samband', label: 'Haft samband', color: '#DBEAFE' }, // Blue
  { id: 'skoðun_bókuð', label: 'Skoðun bókuð', color: '#E9D5FF' }, // Purple
  { id: 'skoðun_lokið', label: 'Skoðun lokið', color: '#D1FAE5' }, // Green
  { id: 'tilboð_gert', label: 'Tilboð gert', color: '#FED7AA' }, // Orange
  { id: 'tilboð_samþykkt', label: 'Tilboð samþykkt', color: '#BFDBFE' }, // Light Blue
  { id: 'kaupsamningur', label: 'Kaupsamningur', color: '#A7F3D0' }, // Light Green
  { id: 'þinglýsing', label: 'Þinglýsing', color: '#C7D2FE' }, // Indigo
  { id: 'afhending', label: 'Afhending', color: '#FED7AA' }, // Orange
  { id: 'lokið', label: 'Lokið', color: '#F3F4F6' }, // Gray
] as const;

export type LeadStageId = typeof LEAD_STAGES[number]['id'];
